module.exports = __webpack_public_path__ + "img/home_bg.379c3a58.jpg";